import { render, staticRenderFns } from "./AppAlertsCoaHistorical.vue?vue&type=template&id=d9209292&scoped=true&"
import script from "./AppAlertsCoaHistorical.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCoaHistorical.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertsCoaHistorical.vue?vue&type=style&index=0&id=d9209292&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9209292",
  null
  
)

export default component.exports